module.exports = __webpack_public_path__ + "static/media/impactClips.09deb375.png";